 class FAQ {
    constructor() {
        this.titles = document.querySelectorAll('.faqs__heading');
        this.addEventListeners();
    }

    addActiveClass(event) {
        const title = event.target.closest('.faqs__heading');
        const wrap = title.parentElement;

        this.titles.forEach(titleElement => {
            if (titleElement !== title) {
                titleElement.parentElement.classList.remove('active');
            }
        });

        wrap.classList.toggle('active');
    }

    addEventListeners() {
        this.titles.forEach(title => {
            title.addEventListener('click', this.addActiveClass.bind(this));
        });
    }
}

new FAQ();